import React from "react";
import TestContainer from "../containers/TestContainer";

const TestPage = () => {
  window.history.pushState(null, null, window.location.href);
  return (
    <>
      <p> 진단평가 테스트 페이지입니다. </p>
      <TestContainer></TestContainer>
    </>
  );
};

export default TestPage;
